import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionStore, SKIP_AUTH } from '@core';
import { Observable } from 'rxjs';

@Injectable()
export class AuthBearerInterceptor implements HttpInterceptor {
  constructor(private readonly sessionStore: SessionStore) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const skipAuth = req.context.get(SKIP_AUTH);

    if (skipAuth) return next.handle(req);

    const accessToken = this.sessionStore.getAccessToken();
    if (!accessToken) return next.handle(req);

    return next.handle(
      req.clone({
        headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
      }),
    );
  }
}
